module.exports = __webpack_public_path__ + "static/media/sf-test-20.d0b371bf.mp3";